import React from 'react';
import { BrainCircuit } from 'lucide-react';
export function VillainSection() {
  return <section className="py-12 px-4 bg-gray-50" data-id="element-139">
      <div className="max-w-4xl mx-auto flex flex-col md:flex-row items-center gap-8 md:gap-12" data-id="element-140">
        {/* Visual Area */}
        <div className="flex-1 flex justify-center" data-id="element-141">
          <div className="relative w-48 h-48 md:w-64 md:h-64 bg-white rounded-full shadow-xl flex items-center justify-center border-4 border-gray-100" data-id="element-142">
            <BrainCircuit className="w-24 h-24 md:w-32 md:h-32 text-gray-300" data-id="element-143" />
            {/* Highlighted Prefrontal Cortex Area (Conceptual) */}
            <div className="absolute top-1/4 left-1/4 w-12 h-12 md:w-16 md:h-16 bg-deep-blue/20 rounded-full blur-md animate-pulse-soft" data-id="element-144"></div>
            <div className="absolute top-1/4 left-1/4 w-8 h-8 md:w-10 md:h-10 bg-deep-blue/40 rounded-full blur-sm" data-id="element-145"></div>
          </div>
        </div>

        {/* Text Area */}
        <div className="flex-1 text-center md:text-left" data-id="element-146">
          <h2 className="text-3xl md:text-4xl font-bold text-deep-blue mb-6 leading-tight" data-id="element-147">
            No es mala educación. <br className="hidden md:block" data-id="element-148" />
            Es biología.
          </h2>

          <p className="text-lg text-gray-700 leading-relaxed" data-id="element-149">
            Silicon Valley diseña apps para secuestrar el cerebro de tu hijo. Tú
            solo necesitas una estrategia técnica de neuro-regulación para
            desactivarlas en 3 minutos. El manual táctico más vendido en España.
          </p>
        </div>
      </div>
    </section>;
}